"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { FONT_WEIGHT_SEMI_BOLD } from "../../../constants/fontWeight.consts.js";
// import components
import MuiTypography from "@mui/material/Typography";
// import utils
import { forwardRef } from "react";
import insertIf from "../../../common-utils/object/objectInsertIf.util.js";
import styled from "../../../client-utils/styled/styled.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
const TypographyComponent = styled(MuiTypography, {
    name: "SdbTypography",
    slot: "Root",
    shouldForwardProp: shouldForwardProp("variant", "size", "prominent"),
})(({ variant = "body", size = "medium", prominent }) => ({
    letterSpacing: "0px",
    weight: 400,
    // Display
    ...insertIf(variant === "display" && size === "small", {
        fontSize: "36px",
        lineHeight: "44px",
    }),
    ...insertIf(variant === "display" && size === "medium", {
        fontSize: "45px",
        lineHeight: "52px",
    }),
    ...insertIf(variant === "display" && size === "large", {
        fontSize: "57px",
        lineHeight: "64px",
        letterSpacing: "-0.25px",
    }),
    // Headline
    ...insertIf(variant === "headline" && size === "small", {
        fontSize: "24px",
        lineHeight: "32px",
    }),
    ...insertIf(variant === "headline" && size === "medium", {
        fontSize: "28px",
        lineHeight: "36px",
    }),
    ...insertIf(variant === "headline" && size === "large", {
        fontSize: "32px",
        lineHeight: "40px",
    }),
    // title
    ...insertIf(variant === "title" && size === "small", {
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.1px",
    }),
    ...insertIf(variant === "title" && size === "medium", {
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
    }),
    ...insertIf(variant === "title" && size === "large", {
        fontSize: "22px",
        lineHeight: "28px",
    }),
    // label
    ...insertIf(variant === "label" && size === "small", {
        fontSize: "11px",
        lineHeight: "16px",
        letterSpacing: "0.5px",
    }),
    ...insertIf(variant === "label" && size === "medium", {
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.5px",
    }),
    ...insertIf(variant === "label" && size === "large", {
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.1px",
    }),
    // body
    ...insertIf(variant === "body" && size === "small", {
        fontSize: "12px",
        lineHeight: "16px",
    }),
    ...insertIf(variant === "body" && size === "medium", {
        fontSize: "14px",
        lineHeight: "20px",
    }),
    ...insertIf(variant === "body" && size === "large", {
        fontSize: "16px",
        lineHeight: "24px",
    }),
    ...insertIf(!!prominent, {
        fontWeight: FONT_WEIGHT_SEMI_BOLD,
    }),
}));
export const TypographyAtomComponent = forwardRef(function Typography(props, ref) {
    return _jsx(TypographyComponent, { "data-testid": "Typography", ref: ref, ...props });
});
export default TypographyAtomComponent;
